import React from 'react';
import PropTypes from 'prop-types';

const Flag = ({ countryCode }) => !!countryCode && <span className={`flag flag-${countryCode.toLowerCase()}`} />;

Flag.defaultProps = {
  countryCode: null
};

Flag.propTypes = {
  countryCode: PropTypes.string
};

export default Flag;
